<div class="voices-top-section">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous" (click)="goBack()">
                <button
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <div class="app-l-page__breadcrumbs">
                <ul class="breadcrumbs-list">
                    <li translate class="breadcrumbs-list-item">
                        <a [routerLink]="['/app/series']" translate
                            >series.title</a
                        >
                    </li>
                    <li translate class="breadcrumbs-list-item">
                        <a [routerLink]="['/app/series/audio']" translate
                            >series.seriesTypes.audio</a
                        >
                    </li>
                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        translate>
                        series.voiceSeries.burningQuestions
                    </li>
                </ul>
            </div>
        </div>
        <div class="app-l-voices-banner">
            <div class="app-l-voices-banner__left">
                <h1 class="app-l-voices-banner__heading" translate>
                    series.voiceSeries.burningQuestions
                </h1>
                <!-- <h6 class="app-l-voices-banner__desc" translate>
                    Lorem ipsum dolor sit amet consectetur. Tortor sit vel.
                </h6> -->
            </div>
        </div>
    </div>
</div>
<div class="app-l-page-wrap">
    <page-loader *ngIf="!loaded"></page-loader>
    <div class="app-l-page-header-block" *ngIf="loaded">
        <div class="app-l-page-title-block">
            <!-- <h2 id="section-title" class="app-l-page-title" translate>
                series.voiceSeries.burningQuestions
            </h2> -->
            <!-- <span class="app-l-count">2</span> -->
        </div>
    </div>
    <div class="app-l-burning-questions-holder">
        <ng-container *ngFor="let category of categorizedBurningQuestionList">
            <div class="app-l-burning-questions-holder_items">
                <div class="app-l-burning-questions-holder_heading" translate>
                    <img
                        class="bq-icon-img"
                        [defaultImage]=""
                        [lazyLoad]="
                            '../../../assets/img/series/bq-category-icons/bq_' +
                            category.categoryKey +
                            '.svg'
                        " />
                    {{ 'series.categories.' + category.categoryKey }}
                </div>

                <owl-carousel-o [options]="customOptions">
                    <ng-template
                        carouselSlide
                        *ngFor="let item of category?.data">
                        <div (click)="goToVoiceStory('burningQuestions', item)">
                            <div class="cover-image-section">
                                <span>{{
                                    item ? item['title_' + lang] : ''
                                }}</span>
                                <img
                                    class="bg-img"
                                    [defaultImage]="
                                        '../../../assets/img/series/voice-bq-default.svg'
                                    "
                                    [lazyLoad]="item.imageUrl" />
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </ng-container>
    </div>
</div>
